import styled from '@emotion/styled'

import { pxToNumber } from '../../../../utils/pxToNumber'
import { STATIC_ACTIONS_SPACING_LEFT, STATIC_ACTIONS_SPACING_RIGHT } from '../TableRow/styles'

export const TableStaticActionsHeaderItemWrapper = styled.div`
  width: ${Math.abs(pxToNumber(STATIC_ACTIONS_SPACING_RIGHT) + pxToNumber(STATIC_ACTIONS_SPACING_LEFT))}px;
`
